
import React from 'react';
import moment from 'moment';
import prettysize from '../../../../../src/utils';

export default (props) =>{
    return (
        <div className="report-list">
            <ul>
                <li>Lucy</li>
                <li>{props.direction} to Wasabi</li>
                <li>{props.source}</li>
                <li>{props.destination}</li>
                <li>{prettysize(props.size)}</li>
                <li>3</li>
                <li>02/05/2001 - 3:04</li>
                <li>{moment(props.date).format('MM/DD/YYYY - hh:mm')}</li>
                {/* <li>
                <Button 
                    className="more-btn"
                    type="primary"
                    // onClick={e =>
                    //     showTriggerConfirm(e, props.handleTriggerClick, props.id, (props.source + " > " + props.destination))
                    // }
                    >More</Button>
                   
                
                </li> */}

                {/* <li>
                    <Tooltip title="Trigger Now">
                    <Button
                        className="replication-upload-btn"
                        icon="upload"
                        onClick={e =>
                            showTriggerConfirm(e, props.handleTriggerClick, props.id, (props.source + " > " + props.destination))
                        }
                    />
                    </Tooltip>
                    <Tooltip title="Delete">
                    <Button
                        className="replication-delete-btn"
                        icon="delete"
                        onClick={e =>
                            showDeleteConfirm(e, props.handleDeleteClick, props.id, (props.source + " > " + props.destination))
                        }
                    />
                    </Tooltip>

                </li> */}
            </ul>
            
        </div>
    )
}

